<template>
  <div class="how-to-play-container">
    <!-- <div class="mask-icon" :class="{ 'm-mask-icon': isMobile }">
      <img class="img-top" src="@/assets/images/howToPlay/mask_top_right.png" alt="">
    </div> -->
    <div class="sections-list">
      <div class="scroll-container">
        <div class="play-tabs-container how-to-play-main-width" v-if="!isMobile">
          <PlayTabs :category-value="categoryValue" :tabs="categoryList" @category-change="handleCategoryChange" />
        </div>
        <div class="section-content">
          <img class="mask mask-bottom" src="@/assets/images/playDetails/mask_bottom.png" alt="">
          <img class="mask img-bottom" src="@/assets/images/howToPlay/mask_left_bottom.png" alt="">
          <el-scrollbar style="height: 100%;" :key="categoryValue">
            <div class="scroll-content how-to-play-main-width" id="scrollContent">
              <div v-if="categoryValue == 'setup-account'">
                <SetupAccount />
              </div>
              <div v-if="categoryValue == 'how-to-earn'">
                <HowToEarn />
              </div>
              <div v-if="categoryValue == 'character-details'">
                <CharacterDetails />
              </div>
              <div v-if="categoryValue == 'case-opening-weapon-synthesis'">
                <CaseWeapon />
              </div>
              <div v-if="categoryValue == 'trading-marketplace'">
                <Marketplace />
              </div>
              <div v-if="categoryValue == 'in-game-marketplace'">
                <InGame />
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
    <div class="mobile-tabs" v-if="isMobile">
      <el-dropdown @command="handleCategoryChange">
        <div class="el-dropdown-link">
          <svg width="166" height="32" viewBox="0 0 166 32" fill="none">
            <path d="M0 0H156.515L166 6.5V32H0V0Z" fill="white" fill-opacity="0.1" />
            <path d="M0.5 0.5H156.36L165.5 6.7635V31.5H0.5V0.5Z" stroke="white" stroke-opacity="0.2" />
          </svg>
          <div class="link-text">
            <div class="text sle">{{ categoryLabel }}</div>
            <i class="el-icon-caret-bottom el-icon--right"></i>
          </div>
        </div>
        <el-dropdown-menu class="custom-dropdown-menu-how-to-play" slot="dropdown">
          <el-dropdown-item :command="item.value" v-for="item in categoryList" :key="item.value">
            {{ item.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import PlayTabs from "./playCategory";
import Bus from "@/libs/bus";
import responsiveMixin from "@/mixins/responsive";
import { playStep } from "@/utils/dict";
import SetupAccount from "./setupAccount/index.vue";
import HowToEarn from "./howToEarn/index.vue";
import CharacterDetails from "./characterDetails/index.vue";
import CaseWeapon from "./caseWeapon/index.vue";
import Marketplace from "./marketplace/index.vue";
import InGame from "./inGame/index.vue";
export default {
  name: "Matr1xFireHowToPlayDetails",
  mixins: [responsiveMixin],
  components: { PlayTabs, SetupAccount, HowToEarn, CharacterDetails, CaseWeapon, Marketplace, InGame },
  data() {
    return {
      categoryValue: this.$route.query.tab || "setup-account",
      categoryList: playStep
    };
  },
  watch: {},
  computed: {
    categoryLabel() {
      return this.categoryList.find(item => item.value == this.categoryValue).label
    }
  },
  mounted() { },
  beforeDestroy() { },
  methods: {
    handleCategoryChange(category) {
      this.categoryValue = category;
    },
  },
  watch: {
    $route: {
      handler(newValue) {
        if (this.isMobile) {
          Bus.$emit("is-open-menu", {
            open: false
          });
        }
        this.$nextTick(() => {
          if (newValue.path == "/play-details") {
            const { tab } = this.$route.query;
            if (tab) {
              this.categoryValue = tab;
            }
          }
        })
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
.how-to-play-main-width {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  font-family: Poppins-Regular !important;
  box-sizing: border-box;

  @media screen and (min-width: 769px) and (max-width: 1400px) {
    max-width: 100%;
    width: 100%;
    padding: 0 40px;
  }

  @media screen and (max-width: 769px) {
    max-width: 100%;
    width: 100%;
    padding: 0 16px;
  }
}
</style>

<style lang="scss" scoped>
@import "./index.scss";
</style>
